import { IPreAuthenticationRequest } from '../../../model/security/request/pre-authentication-request';
import { IPreAuthenticationResponse } from '../../../model/security/response/pre-authentication-response';
import { IAuthenticationRequest } from '../../../model/security/request/authentication-request';

export type LoginState = {
  preAuthenticationRequest: IPreAuthenticationRequest;
  preAuthenticationResponse: IPreAuthenticationResponse;
  authenticationRequest: IAuthenticationRequest;
  showPassword: boolean;
  loading: boolean;
  fieldInvalid: boolean;
};

export enum ACTION_TYPES {
  setPreAuthenticationRequest = 'setPreAuthenticationRequest',
  setPreAuthenticationResponse = 'setPreAuthenticationResponse',
  setAuthenticationRequest = 'setAuthenticationRequest',
  setShowPassword = 'setShowPassword',
  setLoading = 'setLoading',
  setFieldInvalid = 'setFieldInvalid',
  resetForm = 'resetForm',
}

export const LoginReducer = (state: LoginState, action: any): LoginState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.setPreAuthenticationRequest:
      return {
        ...state,
        preAuthenticationRequest: payload,
      };
    case ACTION_TYPES.setPreAuthenticationResponse:
      return {
        ...state,
        preAuthenticationResponse: payload,
      };
    case ACTION_TYPES.setAuthenticationRequest:
      return {
        ...state,
        authenticationRequest: payload,
      };
    case ACTION_TYPES.setShowPassword:
      return {
        ...state,
        showPassword: payload,
      };
    case ACTION_TYPES.setLoading:
      return {
        ...state,
        loading: payload,
      };
    case ACTION_TYPES.setFieldInvalid:
      return {
        ...state,
        fieldInvalid: payload,
      };
    case ACTION_TYPES.resetForm:
      return {
        ...state,
        preAuthenticationRequest: payload.preAuthenticationRequest,
        preAuthenticationResponse: payload.preAuthenticationResponse,
        authenticationRequest: payload.authenticationRequest,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}
